import { APP_BACKEND_URL } from '@/const/env'

export const VACK_PARENT_MESSAGE_TYPES = {
  READY: 'BUSCADOR_READY',
  ERROR: 'BUSCADOR_ERROR'
} as const

function getBackendOrigin(): string {
  return new URL(APP_BACKEND_URL).origin
}

function isEmbeddedInBackend(): boolean {
  try {
    return window.parent !== window && Boolean(APP_BACKEND_URL)
  } catch {
    return false
  }
}

export { isEmbeddedInBackend }

export function notifyParentBuscadorReady() {
  if (!isEmbeddedInBackend()) {
    return
  }

  window.parent.postMessage(
    { type: VACK_PARENT_MESSAGE_TYPES.READY },
    getBackendOrigin()
  )
}

export function notifyParentBuscadorError() {
  if (!isEmbeddedInBackend()) {
    return
  }

  window.parent.postMessage(
    { type: VACK_PARENT_MESSAGE_TYPES.ERROR },
    getBackendOrigin()
  )
}
